<template>
  <PageWrapper
    v-if="canView"
    :active-section="SECTION_PUBLICATIONS"
    :active-page="PAGE_PUBLICATION_PRO_FEATURES"
    title="Publication Pro Features"
    :breadcrumbs="breadcrumbs"
    page-name="Pro Features"
    align="left"
    width="full"
  >
    <PublicationProPlans />
    <PublicationDomainConfiguration />
  </PageWrapper>
  <iText v-else>
    You don't have access to view this page.
  </iText>
</template>

<script>
import { mapState } from "pinia";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import PageWrapper from "@/components/PageWrapper.vue";
import {
  PAGE_PUBLICATION_PRO_FEATURES,
  SECTION_PUBLICATIONS,
} from "@/constants/nav-constants";
import PublicationDomainConfiguration from "@/components/publication/features/PublicationDomainConfiguration.vue";
import PublicationProPlans from "@/components/publication/pro-features/PublicationProPlans.vue";
import { useCollaboratorStore } from "@/stores/collaborator-store";

export default {
  name: "PublicationProFeatures",
  components: {
    PublicationProPlans,
    PageWrapper,
    PublicationDomainConfiguration,
  },
  data() {
    return {
      PAGE_PUBLICATION_PRO_FEATURES,
      SECTION_PUBLICATIONS,
    };
  },
  computed: {
    ...mapState(useCreatorPublicationStore, [
      "orgId",
      "publicationId",
    ]),
    ...mapState(useCollaboratorStore, [
      "canView",
    ]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/publication/org/${this.orgId}`, label: "My Publications" },
        { url: `/publication/${this.publicationId}`, label: "Overview" },
        { url: `/publication/${this.publicationId}/settings`, label: "Settings" },
      ];
    },
  },
  mounted() {
    if (!this.canView) {
      const baseUrl = window.location.origin;
      const redirectUrl = `${baseUrl}/publication/${this.publicationId}`;

      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 2000);
    }
  },
};
</script>

<style scoped>
</style>
